module.exports = __webpack_public_path__ + "static/media/2.f0ecdf8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/2.png
// module id = 1517
// module chunks = 0